/**
 * check resource type with selected
 * @param  {string} type type for checking
 * @return {function}    function with an event as argument
 */
export const isResourceType = type => resource => resource.type === type;
export const isResourceAircraft = isResourceType('Aircraft');
export const isResourceSimulator = isResourceType('Simulator');
export const isResourceInstructor = isResourceType('Instructor');

export const isResourceID = resourecID => resource => resource.id === resourecID;

export function getUserIDByFilterResorces(state, filter) {
  const filterKeys = Object.keys(filter);
  const resources = state.ResourceReducer.resources;
  if (resources && filterKeys.length > 0) {
    const instructorID =
      filter[
        filterKeys.filter(
          key =>
            key.toLowerCase().includes('resource') &&
            resources[filter[key]] &&
            resources[filter[key]].type === 'Instructor'
        )[0]
      ];
    if (instructorID) {
      return resources[instructorID].userID;
    }
  }
  return null;
}

export function getInstructorIDByFilterResources(state, filter) {
  const filterKeys = Object.keys(filter);
  const resources = state.ResourceReducer.resources;
  if (filterKeys.length > 0) {
    return filter[
      filterKeys.filter(
        key =>
          key.toLowerCase().includes('resource') &&
          resources[filter[key]] &&
          resources[filter[key]].type === 'Instructor'
      )[0]
    ];
  }
  return null;
}

export function findPositionResourceByType(state, type) {
  const resources = state.ResourceReducer.resources;
  const filter = state.CalendarReducer.Filter.filter;
  if (filter && resources && type) {
    const index = Object.keys(filter)
      .filter(key => key.toLowerCase().includes('resource'))
      .findIndex(resource =>
        filter[resource]
          ? resources[filter[resource]]
            ? isResourceInstructor(resources[filter[resource]])
            : false
          : false
      );
    return index;
  }
  return null;
}
